/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SmsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Parametres SMS de l'entreprise
     * Les parametres d'envoi de SMS configures dans Lola.
     * @returns string
     * @throws ApiError
     */
    public smsGetParameters(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sms/parameters',
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Envoyer un SMS
     * Via la passerelle SMS avec les identifiants du compte (`user`, `pass`, `sender`) : `text` au numero `gsm`. Reponse : `{ status }` renvoye par la passerelle ; 500 `{ error }` si elle ne repond pas.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public smsSendSms(
        requestBody: {
            gsm: string;
            text: string;
            user: string;
            pass: string;
            sender: string;
        },
    ): CancelablePromise<{
        status: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sms',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Envoyer un code OTP par SMS
     * Demande a la passerelle d'envoyer un code a usage unique au numero `gsm`, avec les identifiants du compte. Reponse : `{ message }` — `Code envoye`, ou `Votre code a deja ete envoye` si un code est encore valide pour ce numero. 500 si la passerelle echoue.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public smsGenerateOtp(
        requestBody: {
            gsm: string;
            user: string;
            pass: string;
            sender: string;
        },
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sms/otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Verifier un code OTP
     * Controle aupres de la passerelle que `code` correspond au dernier code envoye a `gsm`. Reponse : `{ message }` ; erreur si le code est faux ou expire.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public smsVerifyOtp(
        requestBody: {
            gsm: string;
            user: string;
            pass: string;
            code: string;
        },
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sms/otp/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
}
